import {ssrRequestContext} from 'app/ssrContext';

const MAX_AGE_DEFAULT_BROWSER = 30;
export const setCacheMaxAge = (cdnMaxAge, browserMaxAge = MAX_AGE_DEFAULT_BROWSER) => {
  if (cdnMaxAge < browserMaxAge) {
    // Cloudfront always uses the greater value of s-maxage or max-age 🙄
    throw new Error(
      'CDN cache duration must always be greater than or equal to browser cache duration. Default value is 30 seconds.'
    );
  }
  ssrRequestContext.cacheControl = `public, s-maxage=${cdnMaxAge}, max-age=${browserMaxAge}`;
};
